import { useCallback } from "react";
import css from "./PhoneInput.module.css";

/**
 * Phone input — СВОБОДНАЯ строка (15.08, отмена жёсткой маски «8 9XX…»):
 * показывает и отдаёт ровно то, что ввели («+79082114923», канонные «89…»
 * существующих броней — как есть). Канонизацию в вид БД («8»+10) делает бэк
 * (api normalizePhone) при сохранении.
 */
export interface PhoneInputProps {
  value: string;
  onChange: (raw: string) => void;
  placeholder?: string;
  /** Show red border when validation failed (parent decides). */
  hasError?: boolean;
  /** Disable interaction. */
  readonly?: boolean;
  /** Тап по полю — readonly-триггер кастомного пада (БМ5): при readonly
   *  inputmode гасится в "none", системная клавиатура не поднимается.
   *  15.08: в readonly срабатывает по pointerdown с preventDefault — поле не
   *  берёт фокус, iOS-автозум по фокусу невозможен.
   *  e.currentTarget — якорь для поповер-пада у поля (M.5). */
  onTap?: (e: React.MouseEvent<HTMLInputElement>) => void;
  autoFocus?: boolean;
  /** Accessible label passed straight through to the input. */
  ariaLabel?: string;
  /** 06.09 (владелец): поле — хост кастомного пада (data-pad-host): docked
   *  TextPad соседнего поля по тапу сюда не закрывается — пад откроется свой. */
  padHost?: boolean;
}

export function PhoneInput({
  value,
  onChange,
  placeholder = "+79…",
  hasError,
  readonly,
  onTap,
  autoFocus,
  ariaLabel,
  padHost,
}: PhoneInputProps) {
  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange(e.target.value);
    },
    [onChange],
  );

  return (
    <input
      type="tel"
      inputMode={readonly ? "none" : "numeric"}
      className={`${css.input} ${hasError ? css.error : ""}`}
      value={value}
      onChange={handleChange}
      onClick={readonly ? undefined : onTap}
      onPointerDown={readonly && onTap ? (e) => { e.preventDefault(); onTap(e); } : undefined}
      placeholder={placeholder}
      readOnly={readonly}
      autoFocus={autoFocus}
      aria-label={ariaLabel}
      data-pad-host={padHost ? "" : undefined}
      autoComplete="off"
    />
  );
}
